import React from 'react';
import axios from 'axios';
import './App.css';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import Submit from './Submit';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './Terms&Conditions';
import EULA from './EULA';
import Default from './Default';
class  App extends React.Component {

  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <Switch>
            <Route exact path='/' component={Submit} />
            <Route path='/threads' component={Default} />
            <Route path='/categories' component={Default} />
            <Route path='/authors' component={Default} />
            <Route exact path='/privacy-policy' component={PrivacyPolicy} />
            <Route exact path='/terms-and-conditions' component={TermsAndConditions} />
            <Route exact path='/eula' component={EULA} />
          </Switch>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
